import {useState, useEffect} from "react"
import {default as cx} from "classnames"
import {Dropdown} from "primereact/dropdown"
import {Question} from "./shared/Question"
import {wrappedGet} from "../../utilities/AxiosHelper.jsx"

const SelectPreceptor = ({orientation_id, questionText, field, data, emptyError, handle, isRequired = true}) => {
    const [options, setOptions] = useState([])
    const [guestPreceptor, setGuestPreceptor] = useState(false)
    const [loading, setLoading] = useState(true)

    const fetchAssignedPreceptors = () => {
        setLoading(true)

        wrappedGet(`/question-select-from-api/assigned-preceptors/${orientation_id}`)
            .then((response) => {
                const results = response.data.results ?? []
                setOptions(results.map((item) => ({label: item.name ?? item.description, value: String(item.id)})))
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const fetchAllPreceptors = () => {
        setLoading(true)

        wrappedGet(`/question-select-from-api/all-preceptors/${orientation_id}`)
            .then((response) => {
                const results = response.data.results ?? []
                setOptions(results.map((item) => ({label: item.name ?? item.description, value: String(item.id)})))
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const onGuestPreceptorChange = (event) => {
        setGuestPreceptor(event.target.checked)
        if (event.target.checked) {
            fetchAllPreceptors()
        } else {
            fetchAssignedPreceptors()
        }
    }

    useEffect(() => {
        fetchAssignedPreceptors()
    }, [])

    return (
        <>
            <Question questionText={questionText} isRequired={isRequired} />
            <div className="w-100 py-5">
                <Dropdown
                    className={cx("w-100 p-dropdown-tall", {"border border-1 border-danger": emptyError})}
                    options={options}
                    name={field}
                    filter
                    value={data}
                    disabled={loading}
                    placeholder={loading ? "Loading..." : "Select Option"}
                    onChange={(option) => handle(option.value)}
                />
                {emptyError && isRequired && <span className="text-danger mt-n5">Selection is required</span>}

                <div className="form-check form-switch form-check-custom form-check-success form-check-solid py-5">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="id-guest-preceptor"
                        checked={guestPreceptor}
                        onChange={onGuestPreceptorChange}
                    />
                    <label className="form-check-label fw-bold fs-5" htmlFor="id-guest-preceptor2">
                        I had a guest preceptor.
                    </label>
                </div>
            </div>
        </>
    )
}

export default SelectPreceptor
